// import api from "../../api";

const state = {
    talentData: {},
};

const getters = {};

const mutations = {
    addToTalent(state, data) {
        state.talentData = data;
        localStorage.setItem('talentData', JSON.stringify(state.talentData));
    },
    updateTalent(state, data) {
        state.talentData = { ...state.talentData, ...data };
        // console.log(state.talentData)
    },
};

const actions = {};

export const talent = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
